import { render, staticRenderFns } from "./SnackBar.vue?vue&type=template&id=38a9d543"
import script from "./SnackBar.vue?vue&type=script&lang=js"
export * from "./SnackBar.vue?vue&type=script&lang=js"
import style0 from "./SnackBar.vue?vue&type=style&index=0&id=38a9d543&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports